import { getRolePlayTheme } from "@/lib/role-play-theme";
import { isOnTheFly, toRolePlayType } from "@/lib/role-plays/scenario-types";

const SIMULATOR_SLUG = /^\/simulator\/([^/?#]+)/;

/**
 * A practice module's hue (a lib/ui/tones.js name), read from its launch href,
 * so a module wears the same colour on its launch card as on its tags, filter
 * dots and result headers. A role-play module takes its type's hue from
 * ROLE_PLAY_THEME; On-the-Fly takes premium (generated content, §2). Anything
 * else (Conversation Analyzer, Deal Clinic, Stories) returns null and stays
 * neutral.
 */
export function getModuleHue(href) {
  const slug = href?.match(SIMULATOR_SLUG)?.[1];
  if (!slug) return null;
  if (isOnTheFly(slug)) return "premium";
  return getRolePlayTheme(toRolePlayType(slug)).hue ?? null;
}
